import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import TranscriptFolderNameButton from "./TranscriptFolderNameButton";

describe("TranscriptFolderNameButton", () => {
  it("renders a visible-width button containing the folder name", () => {
    render(<TranscriptFolderNameButton name="Quarterly interviews" current onClick={jest.fn()} />);

    const button = screen.getByRole("button", { name: "Quarterly interviews" });
    expect(button.style.minWidth).toBe("64px");
    expect(button.textContent).toContain("Quarterly interviews");
    expect(button.getAttribute("title")).toBe("Quarterly interviews");
    expect(button.getAttribute("aria-current")).toBe("page");
  });

  it("shows the full folder name in a tooltip on hover", async () => {
    render(
      <TranscriptFolderNameButton
        name="Quarterly Budget Review"
        current={false}
        onClick={jest.fn()}
      />,
    );

    fireEvent.mouseOver(screen.getByRole("button", { name: "Quarterly Budget Review" }));

    expect((await screen.findByRole("tooltip")).textContent).toContain("Quarterly Budget Review");
  });
});
